import { Box, Button, CheckBox, Text, TextSpinner } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import type { Return } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useNotifications } from 'modules/shift_management/hooks/useNotifications'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

interface Props {
  onClose: () => void
  onConfirm: () => Promise<Return<void>>
  submitting: boolean
}

const PublishModal = ({ onClose, onConfirm, submitting }: Props) => {
  const [{ sendNotifications }, dispatchNotifications] = useNotifications()
  const [{ view }] = useSchedule()
  const { firstDay, lastDay } = view

  const [hideCallout, setHideCallout] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.shiftManagementHidePublishShiftInfo,
    false
  )

  const onCheckboxClick = () =>
    dispatchNotifications({
      type: 'TOGGLE_SEND_NOTIFICATIONS',
      sendNotifications: !sendNotifications,
    })

  return (
    <Modal
      illustration="handing-paper"
      title={i18n.t('shift_management.publish.modal.title', {
        shortStartAt: firstDay.format('MMM Do'),
        shortEndAt: lastDay.format('MMM Do'),
      })}
      description={i18n.t('shift_management.publish.modal.paragraphs.schedule_week', {
        startAt: firstDay.format('MMMM Do'),
        endAt: lastDay.format('MMMM Do'),
      })}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('shift_management.actions.cancel')}
          </Button>
          <Button disabled={submitting} onClick={onConfirm}>
            {i18n.t('shift_management.actions.publish')}
          </Button>
        </>
      }
    >
      {submitting && <TextSpinner text={i18n.t('shift_management.actions.publishing')} />}
      {!submitting && (
        <Box gap="s24">
          {!hideCallout && (
            <Callout
              type="info"
              description={i18n.t('shift_management.publish.modal.paragraphs.another_week')}
              onRemove={() => setHideCallout(true)}
            />
          )}
          <Box flexDirection="row" gap="s8">
            <Box paddingY="s2">
              <CheckBox checked={sendNotifications} onClick={onCheckboxClick} />
            </Box>
            <Text.Normal size="200" weight="medium">
              {i18n.t('shift_management.publish.modal.notification_checkbox')}
            </Text.Normal>
          </Box>
        </Box>
      )}
    </Modal>
  )
}

export default PublishModal
